import { OwcButton, OwcProgressSpinner, OwcTypography } from '@one/react';
import { useTranslation } from 'core/i18n';
import { ContentWithFooterLayout } from '../layouts';
import { NoConnectionLayout, NoConnectionStatus } from './no-connection-screen.style';

interface NoConnectionScreenProps {
  isChecking: boolean;
  onRetry: VoidFunction;
}

export const NoConnectionScreenComponent: React.FC<NoConnectionScreenProps> = ({
  isChecking,
  onRetry,
}) => {
  const { t } = useTranslation('common');

  return (
    <ContentWithFooterLayout
      footer={
        <OwcButton
          variant="primary"
          disabled={isChecking}
          onClick={onRetry}
          data-testid="no-connection-retry"
        >
          {t('components.no-connection.retry')}
        </OwcButton>
      }
    >
      <NoConnectionLayout>
        <img src="/assets/images/generic-error.svg" alt={t('components.no-connection.alt')} />
        <OwcTypography variant="subtitle1" mode="medium">
          {t('components.no-connection.title')}
        </OwcTypography>
        <OwcTypography variant="body1" mode="regular" className="text-center">
          {t('components.no-connection.message')}
        </OwcTypography>
        <NoConnectionStatus role="status">
          <OwcProgressSpinner size="small" />
          <OwcTypography variant="caption">{t('components.no-connection.trying')}</OwcTypography>
        </NoConnectionStatus>
      </NoConnectionLayout>
    </ContentWithFooterLayout>
  );
};
